/**
 * Build a Gospeleon file URL with an optional resize width.
 *
 * - Bare path → `${API}/files/${path}` (with optional `?w=` for server-side resize).
 * - Path already absolute (http/https) → returned untouched (external avatars / signed URLs).
 * - Falsy/empty → returns `null` so callers can decide on a placeholder.
 *
 * Width presets (rough sizing rules — pick the one closest to your rendered size,
 * doubled for retina-2x where worth it):
 *
 *   - PLAYER_THUMB (160) — 56×56 mini-player thumbnail
 *   - CARD_THUMB (400)   — 160×160 to ~200×200 album/track cards (covers 2x retina)
 *   - HERO (800)         — large detail-page hero covers, ~400-500px wide
 *   - AVATAR (240)       — circular profile pictures up to ~120px
 */
import { API } from '../App';

export const IMG_WIDTHS = {
  PLAYER_THUMB: 160,
  CARD_THUMB: 400,
  HERO: 800,
  AVATAR: 240,
};

export function fileUrl(path, width) {
  if (!path) return null;
  if (typeof path !== 'string') return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const base = `${API}/files/${path}`;
  if (width && Number.isFinite(width)) {
    const sep = base.includes('?') ? '&' : '?';
    return `${base}${sep}w=${width}`;
  }
  return base;
}
